import React, { memo } from 'react';
import defaultClasses from './accountCartHeader.css';
import Account from '@magento/venia-ui/venia-static/icons/account.svg';
import MyAccountMenu from './myAccountMenu';
import { FormattedMessage } from 'react-intl';
import CartTrigger from './cartTrigger';
import { mergeClasses } from '../../classify';
import { useUserContext } from "@magento/peregrine/lib/context/user";
import { useHistory } from "react-router-dom";
var AccountCartHeader = props => {
  var {
    setAccountMenu,
    accountMenu,
    styles = {}
  } = props;
  var [{
    isSignedIn,
    userData,
    currentUser
  }] = useUserContext();
  var history = useHistory();
  var classes = mergeClasses(defaultClasses, {});
  return /*#__PURE__*/React.createElement("div", {
    className: classes.cartHeaderContainer,
    style: styles
  }, /*#__PURE__*/React.createElement("button", {
    className: classes.accountContainer,
    onClick: () => {
      if (isSignedIn) {
        setAccountMenu(accountMenu === 'openAccountMenu' ? 'closeAccountMenu' : 'openAccountMenu');
      } else {
        history.push("/sign-in");
      }
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: Account,
    alt: 'account'
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.accountLabelContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mainLabel
  }, isSignedIn ? /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'navHeader.myAccountText',
    defaultMessage: 'My Account'
  }) : /*#__PURE__*/React.createElement(FormattedMessage, {
    id: 'accountTrigger.signIn',
    defaultMessage: 'Sign In'
  }))), isSignedIn ? /*#__PURE__*/React.createElement(MyAccountMenu, {
    accountMenu: accountMenu,
    setAccountMenu: setAccountMenu,
    user: currentUser && currentUser.firstname ? currentUser : userData
  }) : null), /*#__PURE__*/React.createElement(CartTrigger, {
    classes: classes
  }));
};
export default memo(AccountCartHeader);